import { Component, Input, OnInit, OnChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatOption } from '@angular/material/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { messageService } from 'src/app/message.service';
import { qmsService } from 'src/app/qms/qms.service';
import { StaticAuditTrailComponent } from 'src/app/support/static-audit-trail/static-audit-trail.component';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { DocumentViewerComponent } from 'src/app/support/document-viewer/document-viewer.component';
import { DocViewerConfig } from 'src/app/support/models/doc-viewer-config.model';

@Component({
  selector: 'app-stage-user',
  templateUrl: './stage-user.component.html',
  styleUrls: ['./stage-user.component.scss']
})
export class StageUserDialogComponent implements OnInit, OnChanges {

  @Input() data: any = {};
  @Input() isReadOnly: boolean = false;
  userTimezone: string = 'Asia/Kolkata';
  isProcessing = false;
  stageData: any;
  taskStagesList: any = [];
  stageUserList: any[] = [];
  stageUserData: any = {};
  searchValue: string = '';
  operationFlag: any;
  title = "";
  noIfAnyList: any = [];
  anyOrAllList: any = [];
  moduleStagesList: any = [];
  usersList: any = [];
  levels: any = [];
  userRolesList: any = [];
  isShowUserRoleSingle = true;
  isShowLevelSingle = true;
  stage: any;

  showingRowsText = "Showing rows";
  perPage = 10;
  maxSize = 3;
  collectionSize: number;

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;

  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  visibleAddOrEditStageUserPopup: MatDialogRef<TemplateRef<any>>;
  visibleEditStagePopup: MatDialogRef<TemplateRef<any>>;
  visibleDeleteStageUserPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addOrEditStageUserPopup', { static: true }) addOrEditStageUserPopup: TemplateRef<any>;
  @ViewChild('editStagePopup', { static: true }) editStagePopup: TemplateRef<any>;
  @ViewChild('deleteStageUserPopup', { static: true }) deleteStageUserPopup: TemplateRef<any>;

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };
  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: false,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  editStagePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  addOrEditStageUserPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deleteStageUserPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  constructor(public appService: AppService, private readonly snackBar: MatSnackBar, public paginationService: PaginationService, public dialog: MatDialog,
    public qmsservice: qmsService, public message: messageService) {

  }

  ngOnInit() {
    this.userTimezone = localStorage.getItem('timezone') || 'Asia/Kolkata';
    this.noIfAnyList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    this.anyOrAllList = [{ codelistCode: "ANY", codelistName: "Any" }, { codelistCode: "ALL", codelistName: "All" }]
    for (const element of this.noIfAnyList) {
      this.noIfAnyDropdown = this.noIfAnyDropdown.concat({
        valueExp: element,
        displayExp: element
      });
    }
    for (const element of this.anyOrAllList) {
      this.anyOrAllDropdown = this.anyOrAllDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }

    // Add this privilege check
    this.appService.userPrivsDetails(this.message.getUserId()).subscribe((response: any = {}) => {
      if (response) {
        this.message.showSwitchUser = response.funcRoles.includes("Switch User");
        this.message.isAuditTrailUser = response.funcRoles.includes("Audit Trail User");
      } else {
        this.message.showSwitchUser = false;
        this.message.isAuditTrailUser = false;
      }
    });
  }

  commonId: any;
  commonVersion: any;
  userPrivData: any = {};
  isSaveButton: boolean = false;
  ngOnChanges() {
    if (this.data.module == "TRN") {
      this.commonId = this.data['trainingId'];
      this.commonVersion = this.data['version'];
    } else if (this.data.module == "DOCS_EXTENSION") {
      this.commonId = this.data['extensionId'];
      this.commonVersion = 0;
    } else if (this.data.module == "BP_SETUP") {
      this.commonId = this.data['setupId'];
      this.commonVersion = 0;
    } else if (this.data.module == "DOCS_WITHDRAWAL") {
      this.commonId = this.data['withdrawalId'];
      this.commonVersion = 0;
    } else if (this.data.module == "DOCS_DESTRUCTION") {
      this.commonId = this.data['destructId'];
      this.commonVersion = 0;
    } else if (this.data.module == "FORMS") {
      this.commonId = this.data['formId'];
      this.commonVersion = 0;
    } else if (this.data.module == "BP_SETUP_exp") {
      this.commonId = this.data['executionId'];
      this.commonVersion = this.data['workflowStageId'];
    } else {
      this.commonId = this.data['documentId'];
      this.commonVersion = this.data['version'];
      this.appService.getDocumentPrivUser(this.data['folderId']).subscribe((data: any) => {
        this.userPrivData = data[0];
      })
    }

    this.isProcessing = true;
    this.appService.getTaskStages(this.commonId, this.commonVersion)
      .subscribe((data: any) => {
        this.taskStagesList = data;
        for (const element of this.taskStagesList) {
          if (element.moduleStagesList.length > 0) {
            if (element.moduleStagesList[0].overridable == "Y") {
              element.isOverriden = true;
            }
          }
          this.getUsersForStages(element);
        }
        this.isProcessing = false;
      })
  }

  refreshStageUsersGrid(stage: any) {
    this.getUsersForStages(stage);
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  makeStickyColumns: any;

  dataGridParentCheckBoxChecked(e: any, stage: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of stage.taskStageUsersList) {
        element.childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (const element of stage.taskStageUsersList) {
        element.childCheckBoxs = false;
      }
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }

  getUsersForStages(stage: any) {
    this.appService.getTaskStageUsers(stage['refNo'], stage['version'], stage['stageName'])
      .subscribe((data: any) => {
        
        if (data && data.length > 0) {
          data.forEach((user: any) => {
            if (user.requestedOn) {
              new Date(user.requestedOn);
            }
            if (user.completedOn ) {
             new Date(user.completedOn)
            }
          });
        }

        stage['taskStageUsersList'] = data;
      })
  }

  refreshGrid(stage: any) {
    this.getUsersForStages(stage);
  }

  editStageFunc(stage: any) {
    this.selectedNoIfAny = [];
    this.selectedNoIfAnyValue = "";
    this.selectedAnyOrAll = [];
    this.selectedAnyOrAllValue = "";
    this.stageData = stage;
    this.selectedNoIfAnyValue = stage.noIfAny;
    this.selectedAnyOrAllValue = stage.anyOrAll;
    if (stage.noIfAny) {
      for (const element of this.noIfAnyDropdown) {
        if (element.valueExp == stage.noIfAny) {
          this.selectedNoIfAny = element.valueExp;
        }
      }
    } else {
      this.selectedNoIfAny = '';
    }
    if (stage.anyOrAll) {
      for (const element of this.anyOrAllDropdown) {
        if (element.valueExp == stage.anyOrAll) {
          this.selectedAnyOrAll = element.valueExp;
        }
      }
    } else {
      this.selectedAnyOrAll = '';
    }
    this.visibleEditStagePopup = this.dialog.open(this.editStagePopup, this.editStagePopupConfig);
  }

  addStageUserFunc(stage: any) {
    this.stageData = stage;
    this.stageUserData = {};
    this.stageUserData['userId'] = "";
    this.stageUserData['userLevel'] = "";
    this.stageUserData['userRole'] = "";
    this.stageUserData['taskStageUserId'] = "";
    this.selectedUserValue = "";
    this.selectedUserRoleValue = "";
    this.selectedLevelValue = "";
    this.selectedLevel = [];
    this.selectedUser = [];
    this.selectedUserRole = [];
    this.userDropdown = [];
    this.levelDropdown = [];
    this.userRoleDropdown = [];
    this.isAllUsersSelected = false;
    this.isProcessing = true;
    this.appService.getModuleStages(stage['module'], stage['stageName'])
      .subscribe((data: any) => {
        this.isProcessing = false;
        this.moduleStagesList = data;
        if (this.moduleStagesList[0]['userRoles'] != null) {
          this.userRolesList = this.moduleStagesList[0]['userRoles'].split(",");
          if (this.userRolesList.length > 0 && this.userRolesList.length == 1) {
            this.isShowUserRoleSingle = true;
            this.selectedUserRoleValue = this.userRolesList[0];
          } else if (this.userRolesList.length > 1) {
            this.isShowUserRoleSingle = false;
            for (const element of this.userRolesList) {
              this.userRoleDropdown = this.userRoleDropdown.concat({
                valueExp: element,
                displayExp: element
              });
            }
          }
        }
        if (this.moduleStagesList[0]['noOfLevels']) {
          if (this.moduleStagesList[0]['noOfLevels'] == 1) {
            this.isShowLevelSingle = true;
            this.selectedLevelValue = 1;
          } else {
            let j = 1;
            while (j > this.moduleStagesList[0]['noOfLevels']) {
              this.levels.push(j);
              j++;
            }
            this.isShowLevelSingle = false;
            for (const element of this.levels) {
              this.levelDropdown = this.levelDropdown.concat({
                valueExp: element,
                displayExp: element
              });
            }

            if (stage.taskStageUsersList.length == 0) {
              this.selectedLevel = [{
                valueExp: this.levelDropdown[0].valueExp,
                displayExp: this.levelDropdown[0].displayExp
              }]
              this.selectedLevelValue = this.levelDropdown[0].valueExp;
            }
          }
        } else {
          this.levels = [];
          if (stage.taskStageUsersList.length > 0) {
            const level = stage.taskStageUsersList[stage.taskStageUsersList.length - 1].userLevel;
            for (let i = 1; i <= level; i++) {
              this.levels.push(i);
            }
            this.levels.push(level + 1);
          } else {
            this.levels.push(1);
          }

          this.isShowLevelSingle = false;
          for (const element of this.levels) {
            this.levelDropdown = this.levelDropdown.concat({
              valueExp: element,
              displayExp: element
            });
          }

          if (stage.taskStageUsersList.length == 0) {
            this.selectedLevel = [{
              valueExp: this.levelDropdown[0].valueExp,
              displayExp: this.levelDropdown[0].displayExp
            }]
            this.selectedLevelValue = this.levelDropdown[0].valueExp;
          }
        }
        this.getAllModuleStageUsersList(stage);
      })


    this.stageUserData['module'] = stage['module'];
    this.stageUserData['refNo'] = stage['refNo'];
    this.stageUserData['refDetails'] = stage['refDetails'];
    this.stageUserData['stageName'] = stage['stageName'];
    this.stageUserData['version'] = stage['version'];
    this.operationFlag = "ADD";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.title = stage.stageName;
    this.qmsservice.isSwitchUSerPopupOpened = false;
    this.visibleAddOrEditStageUserPopup = this.dialog.open(this.addOrEditStageUserPopup, this.addOrEditStageUserPopupConfig);
  }

  getUserForStagesForDoc(role: any) {
    if (role != "" && role != null) {
      this.userDropdown = [];
      this.isProcessing = true;
      this.appService.getUserListOfDocForStageUser(role, this.data['folderId'], this.data['isBlinded']).subscribe((data: any) => {
        this.userDropdown = [];
        this.usersList = data;
        this.isProcessing = false;
        for (const element of this.usersList) {
          this.userDropdown = this.userDropdown.concat({
            valueExp: element.userOrRoleId,
            displayExp: element.userOrRoleName
          });
        }
        this.message.switchUserdropDownList = this.userDropdown;
        if (this.stageUserData.taskStageUsersPk != undefined) {
          if (this.stageUserData.taskStageUsersPk.userId != null) {
            let usersValues = this.userDropdown.filter((x: any) => x.valueExp === this.stageUserData.taskStageUsersPk.userId);
            if (usersValues.length != 0) {
              this.message.currentSwitchuser = this.message.switchedUser = this.selectedUser = usersValues[0].valueExp;
            }
          }
        }
        if (this.stageUserData.taskStageUsersPk != undefined) {
          if (this.stageUserData.taskStageUsersPk.userId != null) {
            for (const element of this.userDropdown) {
              if (element.valueExp == this.stageUserData.taskStageUsersPk.userId) {
                this.selectedUser = [{
                  valueExp: element.valueExp,
                  displayExp: element.displayExp
                }]
                this.selectedUserValue = element.valueExp;
              }
            }
          }
        }

      })
    }

  }

  selectBoxLogic() {
    for (const element of this.usersList) {
      if (!this.userDropdown.some((user: any) => user.valueExp === element.userId)) {
        this.userDropdown = this.userDropdown.concat({
          valueExp: element.userId,
          displayExp: element.userName + "(" + element.lastName + ", " + element.firstName + ")"
        });
      }
    }
    this.message.switchUserdropDownList = this.userDropdown;
    if (this.stageUserData.taskStageUsersPk != undefined) {
      if (this.stageUserData.taskStageUsersPk.userId != null) {
        let usersValues = this.usersList.filter((x: any) => x.userId === this.stageUserData.taskStageUsersPk.userId);
        if (usersValues.length != 0) {
          this.message.currentSwitchuser = this.message.switchedUser = this.selectedUser = usersValues[0].userId;
        }
      }
    }
    if (this.stageUserData.taskStageUsersPk != undefined) {
      if (this.stageUserData.taskStageUsersPk.userId != null) {
        for (const element of this.userDropdown) {
          if (element.valueExp == this.stageUserData.taskStageUsersPk.userId) {
            this.selectedUser = [{
              valueExp: element.valueExp,
              displayExp: element.displayExp
            }]
            this.selectedUserValue = element.valueExp;
          }
        }
      }
    }
  }

  getAllModuleStageUsersList(stage: any) {
    if (this.data['module'] == "TRN") {
      this.userDropdown = [];
      this.isProcessing = true;
      this.appService.getUsersListForStageUsers(this.data.categoryCode).subscribe((data: any) => {
        this.userDropdown = [];
        this.usersList = data;
        this.isProcessing = false;
        for (const element of this.usersList) {
          this.userDropdown = this.userDropdown.concat({
            valueExp: element.userId,
            displayExp: element.userFullname
          });
        }
        this.message.switchUserdropDownList = this.userDropdown;
        if (this.stageUserData.taskStageUsersPk != undefined) {
          if (this.stageUserData.taskStageUsersPk.userId != null) {
            let usersValues = this.usersList.filter((x: any) => x.userId === this.stageUserData.taskStageUsersPk.userId);
            if (usersValues.length != 0) {
              this.message.currentSwitchuser = this.message.switchedUser = this.selectedUser = usersValues[0].userId;
            }
          }
        }
        if (this.stageUserData.taskStageUsersPk != undefined) {
          if (this.stageUserData.taskStageUsersPk.userId != null) {
            for (const element of this.userDropdown) {
              if (element.valueExp == this.stageUserData.taskStageUsersPk.userId) {
                this.selectedUser = [{
                  valueExp: element.valueExp,
                  displayExp: element.displayExp
                }]
                this.selectedUserValue = element.valueExp;
              }
            }
          }
        }
      })
    } else if (this.data['module'] == "BP_SETUP") {
      this.userDropdown = [];
      this.isProcessing = true;
      this.appService.getReviewerAndApproverListForBPSetup(stage.stageName).subscribe((data: any) => {
        this.userDropdown = [];
        this.usersList = data;
        this.isProcessing = false;
        for (const element of this.usersList) {
          this.userDropdown = this.userDropdown.concat({
            valueExp: element.userId,
            displayExp: element.userName
          });
        }
        this.message.switchUserdropDownList = this.userDropdown;
        if (this.stageUserData.taskStageUsersPk != undefined) {
          if (this.stageUserData.taskStageUsersPk.userId != null) {
            let usersValues = this.usersList.filter((x: any) => x.userId === this.stageUserData.taskStageUsersPk.userId);
            if (usersValues.length != 0) {
              this.message.currentSwitchuser = this.message.switchedUser = this.selectedUser = usersValues[0].userId;
            }
          }
        }
        if (this.stageUserData.taskStageUsersPk != undefined) {
          if (this.stageUserData.taskStageUsersPk.userId != null) {
            for (const element of this.userDropdown) {
              if (element.valueExp == this.stageUserData.taskStageUsersPk.userId) {
                this.selectedUser = [{
                  valueExp: element.valueExp,
                  displayExp: element.displayExp
                }]
                this.selectedUserValue = element.valueExp;
              }
            }
          }
        }
      })
    } else if (this.data['module'] == "BP_SETUP_exp") {
      this.userDropdown = [];
      this.isProcessing = true;
      this.appService.getReviewerAndApproverListForBPexcutionSetup(this.appService.excutionDetails.SETUP_ID + "/" + this.appService.excutionDetails.WORKFLOW_ID + "/" + this.appService.excutionDetails.WORKFLOW_STAGE_ID + "/" + stage.stageName).subscribe((data: any) => {
        this.userDropdown = [];
        this.usersList = data;
        this.isProcessing = false;
        for (const element of this.usersList) {
          this.userDropdown = this.userDropdown.concat({
            valueExp: element.userId,
            displayExp: element.userName
          });
        }
        this.message.switchUserdropDownList = this.userDropdown;
        if (this.stageUserData.taskStageUsersPk != undefined) {
          if (this.stageUserData.taskStageUsersPk.userId != null) {
            let usersValues = this.usersList.filter((x: any) => x.userId === this.stageUserData.taskStageUsersPk.userId);
            if (usersValues.length != 0) {
              this.message.currentSwitchuser = this.message.switchedUser = this.selectedUser = usersValues[0].userId;
            }
          }
        }
        if (this.stageUserData.taskStageUsersPk != undefined) {
          if (this.stageUserData.taskStageUsersPk.userId != null) {
            for (const element of this.userDropdown) {
              if (element.valueExp == this.stageUserData.taskStageUsersPk.userId) {
                this.selectedUser = [{
                  valueExp: element.valueExp,
                  displayExp: element.displayExp
                }]
                this.selectedUserValue = element.valueExp;
              }
            }
          }
        }
      })
    } else if (this.data['module'] == "FORMS") {
      this.userDropdown = [];
      this.isProcessing = true;
      this.appService.getAddedFormUsers(this.data.templateId, this.data.formId).subscribe((data: any) => {
        this.userDropdown = [];
        this.usersList = [];
        for (const element of data) {
          if (element.verifyFormData == "Y") {
            this.usersList.push(element);
          }
        }
        this.isProcessing = false;
        for (const element of this.usersList) {
          this.userDropdown = this.userDropdown.concat({
            valueExp: element.userId,
            displayExp: element.userName
          });
        }
        this.message.switchUserdropDownList = this.userDropdown;
        if (this.stageUserData.taskStageUsersPk != undefined) {
          if (this.stageUserData.taskStageUsersPk.userId != null) {
            let usersValues = this.usersList.filter((x: any) => x.userId === this.stageUserData.taskStageUsersPk.userId);
            if (usersValues.length != 0) {
              this.message.currentSwitchuser = this.message.switchedUser = this.selectedUser = usersValues[0].userId;
            }
          }
        }
        if (this.stageUserData.taskStageUsersPk != undefined) {
          if (this.stageUserData.taskStageUsersPk.userId != null) {
            for (const element of this.userDropdown) {
              if (element.valueExp == this.stageUserData.taskStageUsersPk.userId) {
                this.selectedUser = [{
                  valueExp: element.valueExp,
                  displayExp: element.displayExp
                }]
                this.selectedUserValue = element.valueExp;
              }
            }
          }
        }
      })
    } else if (this.data['module'] == "DOCS_EXTENSION" || this.data['module'] == "DOCS_WITHDRAWAL" || this.data['module'] == "DOCS_DESTRUCTION") {
      this.usersList = [];
      this.getUserForStagesForDoc(this.selectedUserRoleValue);
    } else if (this.data['module'] == "DOCS") {
      if (this.data['belongsToIndividual'] == 'Y') {
        if ((this.userPrivData.author == "Y" && this.selectedUserRoleValue == 'Author') || (this.userPrivData.reviewer == "Y" && this.selectedUserRoleValue == 'Reviewer') ||
          (this.userPrivData.approver == "Y" && this.selectedUserRoleValue == 'Approver') || (this.userPrivData.qa == "Y" && this.selectedUserRoleValue == 'QA')
          || (this.userPrivData.trainingCoordinator == "Y" && this.selectedUserRoleValue == 'Training Coordinator')
          || (this.userPrivData.authorizer == "Y" && this.selectedUserRoleValue == 'Authorizer')) {
          this.userDropdown = [];
          this.usersList = [];
          this.appService.getUserListOfDocForStageUser(this.selectedUserRoleValue, this.data['folderId'], this.data['isBlinded']).subscribe((data: any) => {
            this.userDropdown = [];
            for (const element of data) {
              this.userDropdown = this.userDropdown.concat({
                valueExp: element.userOrRoleId,
                displayExp: element.userOrRoleName
              });
            }
            if ((this.userPrivData.allusrAuthor == "Y" && this.selectedUserRoleValue == 'Author') || (this.userPrivData.allusrReviewer == "Y" && this.selectedUserRoleValue == 'Reviewer') || (this.userPrivData.allusrApprover == "Y" && this.selectedUserRoleValue == 'Approver')) {
              this.appService.userDetailsByName(this.data['belongsUserName']).subscribe((data: any) => {
                if (data.length > 0) {
                  if (data[0].isActive == "Y") {
                    this.usersList.push(data[0]);
                  }
                }
                if ((this.userPrivData.rmAuthor == "Y" && this.selectedUserRoleValue == 'Author') || (this.userPrivData.rmReviewer == "Y" && this.selectedUserRoleValue == 'Reviewer') || (this.userPrivData.rmApprover == 'Y' && this.selectedUserRoleValue == 'Approver')) {

                  this.appService.getManagerList(this.data['belongsUserId']).subscribe((data: any) => {
                    if (data.length > 0) {
                      if (data[0].isActive == "Y") {
                        if (!this.usersList.some((user: any) => user.userId === data[0].userId)) {
                          this.usersList.push(data[0]);
                        }
                      }
                    }
                    this.selectBoxLogic();
                  })
                } else {
                  this.selectBoxLogic();
                }
              })
            } else if ((this.userPrivData.rmAuthor == "Y" && this.selectedUserRoleValue == 'Author') || (this.userPrivData.rmReviewer == "Y" && this.selectedUserRoleValue == 'Reviewer') || (this.userPrivData.rmApprover == 'Y' && this.selectedUserRoleValue == 'Approver')) {
              this.appService.getManagerList(this.data['belongsUserId']).subscribe((data: any) => {
                if (data.length > 0) {
                  if (data[0].isActive == "Y") {
                    if (!this.usersList.some((user: any) => user.userId === data[0].userId)) {
                      this.usersList.push(data[0]);
                    }

                  }
                }
                this.selectBoxLogic();
              })
            } else {
              this.message.switchUserdropDownList = this.userDropdown;
              if (this.stageUserData.taskStageUsersPk != undefined) {
                if (this.stageUserData.taskStageUsersPk.userId != null) {
                  let usersValues = this.usersList.filter((x: any) => x.userId === this.stageUserData.taskStageUsersPk.userId);
                  if (usersValues.length != 0) {
                    this.message.currentSwitchuser = this.message.switchedUser = this.selectedUser = usersValues[0].userId;
                  }
                }
              }
              if (this.stageUserData.taskStageUsersPk != undefined) {
                if (this.stageUserData.taskStageUsersPk.userId != null) {
                  for (const element of this.userDropdown) {
                    if (element.valueExp == this.stageUserData.taskStageUsersPk.userId) {
                      this.selectedUser = [{
                        valueExp: element.valueExp,
                        displayExp: element.displayExp
                      }]
                      this.selectedUserValue = element.valueExp;
                    }
                  }
                }
              }
            }
          })
        } else if ((this.userPrivData.allusrAuthor == "Y" && this.userPrivData.rmAuthor == "Y" && this.selectedUserRoleValue == 'Author') || (this.userPrivData.allusrReviewer == "Y" && this.userPrivData.rmReviewer == "Y" && this.selectedUserRoleValue == 'Reviewer') ||
          (this.userPrivData.allusrApprover == "Y" && this.userPrivData.rmApprover == "Y" && this.selectedUserRoleValue == 'Approver')) {
          this.usersList = [];
          this.userDropdown = [];
          this.appService.userDetailsByName(this.data['belongsUserName']).subscribe((data: any) => {
            this.usersList = [];
            this.userDropdown = [];
            if (data.length > 0) {
              if (data[0].isActive == "Y") {
                this.usersList.push(data[0]);
              }
            }
            this.appService.getManagerList(this.data['belongsUserId']).subscribe((data: any) => {
              if (data.length > 0) {
                if (data[0].isActive == "Y" && this.usersList.indexOf(data[0])) {
                  if (!this.usersList.some((user: any) => user.userId === data[0].userId)) {
                    this.usersList.push(data[0]);
                  }
                }
              }
              this.appService.getUserListOfDocForStageUser(this.selectedUserRoleValue, this.data['folderId'], this.data['isBlinded']).subscribe((data: any) => {
                for (const element of data) {
                  this.userDropdown = this.userDropdown.concat({
                    valueExp: element.userOrRoleId,
                    displayExp: element.userOrRoleName
                  });
                }
                for (const element of this.usersList) {
                  if (!this.userDropdown.some((user: any) => user.valueExp === element.userId)) {
                    this.userDropdown = this.userDropdown.concat({
                      valueExp: element.userId,
                      displayExp: element.userName + "(" + element.lastName + ", " + element.firstName + ")"
                    });
                  }

                }
                this.message.switchUserdropDownList = this.userDropdown;
                if (this.stageUserData.taskStageUsersPk != undefined) {
                  if (this.stageUserData.taskStageUsersPk.userId != null) {
                    let usersValues = this.userDropdown.filter((x: any) => x.valueExp === this.stageUserData.taskStageUsersPk.userId);
                    if (usersValues.length != 0) {
                      this.message.currentSwitchuser = this.message.switchedUser = this.selectedUser = usersValues[0].valueExp;
                    }
                  }
                }
                if (this.stageUserData.taskStageUsersPk != undefined) {
                  if (this.stageUserData.taskStageUsersPk.userId != null) {
                    for (const element of this.userDropdown) {
                      if (element.valueExp == this.stageUserData.taskStageUsersPk.userId) {
                        this.selectedUser = [{
                          valueExp: element.valueExp,
                          displayExp: element.displayExp
                        }]
                        this.selectedUserValue = element.valueExp;
                      }
                    }
                  }
                }
              })
            })
          })
        } else if ((this.userPrivData.allusrAuthor == "Y" && this.selectedUserRoleValue == 'Author') || (this.userPrivData.allusrReviewer == "Y" && this.selectedUserRoleValue == 'Reviewer') || (this.userPrivData.allusrApprover == "Y" && this.selectedUserRoleValue == 'Approver')) {
          this.usersList = [];
          this.userDropdown = [];
          this.appService.userDetailsByName(this.data['belongsUserName']).subscribe((data: any) => {
            this.usersList = [];
            this.userDropdown = [];
            if (data.length > 0) {
              if (data[0].isActive == "Y") {
                this.usersList.push(data[0]);
              }
            }
            this.appService.getUserListOfDocForStageUser(this.selectedUserRoleValue, this.data['folderId'], this.data['isBlinded']).subscribe((data: any) => {

              for (const element of data) {
                this.userDropdown = this.userDropdown.concat({
                  valueExp: element.userOrRoleId,
                  displayExp: element.userOrRoleName
                });
              }
              for (const element of this.usersList) {
                if (!this.userDropdown.some((user: any) => user.valueExp === element.userId)) {
                  this.userDropdown = this.userDropdown.concat({
                    valueExp: element.userId,
                    displayExp: element.userName + "(" + element.lastName + ", " + element.firstName + ")"
                  });
                }

              }
              this.message.switchUserdropDownList = this.userDropdown;
              if (this.stageUserData.taskStageUsersPk != undefined) {
                if (this.stageUserData.taskStageUsersPk.userId != null) {
                  let usersValues = this.userDropdown.filter((x: any) => x.valueExp === this.stageUserData.taskStageUsersPk.userId);
                  if (usersValues.length != 0) {
                    this.message.currentSwitchuser = this.message.switchedUser = this.selectedUser = usersValues[0].valueExp;
                  }
                }
              }
              if (this.stageUserData.taskStageUsersPk.userId != null) {
                for (const element of this.userDropdown) {
                  if (element.valueExp == this.stageUserData.taskStageUsersPk.userId) {
                    this.selectedUser = [{
                      valueExp: element.valueExp,
                      displayExp: element.displayExp
                    }]
                    this.selectedUserValue = element.valueExp;
                  }
                }
              }
            })

          })
        } else if ((this.userPrivData.rmAuthor == "Y" && this.selectedUserRoleValue == 'Author') || (this.userPrivData.rmReviewer == "Y" && this.selectedUserRoleValue == 'Reviewer') || (this.userPrivData.rmApprover == 'Y' && this.selectedUserRoleValue == 'Approver')) {
          this.usersList = [];
          this.userDropdown = [];
          this.appService.getManagerList(this.data['belongsUserId']).subscribe((data: any) => {
            this.usersList = [];
            this.userDropdown = [];
            if (data.length > 0) {
              if (data[0].isActive == "Y") {
                this.usersList.push(data[0]);
              }
            }
            this.appService.getUserListOfDocForStageUser(this.selectedUserRoleValue, this.data['folderId'], this.data['isBlinded']).subscribe((data: any) => {

              for (const element of data) {
                this.userDropdown = this.userDropdown.concat({
                  valueExp: element.userOrRoleId,
                  displayExp: element.userOrRoleName
                });
              }
              for (const element of this.usersList) {
                if (!this.userDropdown.some((user: any) => user.valueExp === element.userId)) {
                  this.userDropdown = this.userDropdown.concat({
                    valueExp: element.userId,
                    displayExp: element.userName + "(" + element.lastName + ", " + element.firstName + ")"
                  });
                }
              }
              this.message.switchUserdropDownList = this.userDropdown;
              if (this.stageUserData.taskStageUsersPk != undefined) {
                if (this.stageUserData.taskStageUsersPk.userId != null) {
                  let usersValues = this.userDropdown.filter((x: any) => x.valueExp === this.stageUserData.taskStageUsersPk.userId);
                  if (usersValues.length != 0) {
                    this.message.currentSwitchuser = this.message.switchedUser = this.selectedUser = usersValues[0].valueExp;
                  }
                }
              }
              if (this.stageUserData.taskStageUsersPk != undefined) {
                if (this.stageUserData.taskStageUsersPk.userId != null) {
                  for (const element of this.userDropdown) {
                    if (element.valueExp == this.stageUserData.taskStageUsersPk.userId) {
                      this.selectedUser = [{
                        valueExp: element.valueExp,
                        displayExp: element.displayExp
                      }]
                      this.selectedUserValue = element.valueExp;
                    }
                  }
                }
              }
            })

          })
        } else {
          this.usersList = [];
          this.userDropdown = [];
          this.appService.getUserListOfDocForStageUser(this.selectedUserRoleValue, this.data['folderId'], this.data['isBlinded']).subscribe((data: any) => {
            this.usersList = [];
            this.userDropdown = [];
            for (const element of data) {
              this.userDropdown = this.userDropdown.concat({
                valueExp: element.userOrRoleId,
                displayExp: element.userOrRoleName
              });
            }

            this.message.switchUserdropDownList = this.userDropdown;
            if (this.stageUserData.taskStageUsersPk != undefined) {
              if (this.stageUserData.taskStageUsersPk.userId != null) {
                let usersValues = data.filter((x: any) => x.userOrRoleId === this.stageUserData.taskStageUsersPk.userId);
                if (usersValues.length != 0) {
                  this.message.currentSwitchuser = this.message.switchedUser = this.selectedUser = usersValues[0].userOrRoleId;
                }
              }
            }
            if (this.stageUserData.taskStageUsersPk != undefined) {
              if (this.stageUserData.taskStageUsersPk.userId != null) {
                for (const element of this.userDropdown) {
                  if (element.valueExp == this.stageUserData.taskStageUsersPk.userId) {
                    this.selectedUser = [{
                      valueExp: element.valueExp,
                      displayExp: element.displayExp
                    }]
                    this.selectedUserValue = element.valueExp;
                  }
                }
              }
            }
          })
        }
      } else {
        this.usersList = [];
        this.userDropdown = [];
        this.getUserForStagesForDoc(this.selectedUserRoleValue);
      }
    }
  }

  editStageUserFunc(stage: any, user: any) {
    this.stageData = stage;
    this.stageUserData = user;
    this.isProcessing = true;
    this.userDropdown = [];
    this.levelDropdown = [];
    this.userRoleDropdown = [];
    this.selectedLevel = [];
    this.selectedLevelValue = "";
    this.selectedUser = [];
    this.selectedUserValue = "";
    this.selectedUserRole = [];
    this.selectedUserRoleValue = "";

    this.appService.getModuleStages(stage['module'], stage['stageName'])
      .subscribe((data: any) => {
        this.isProcessing = false;
        this.moduleStagesList = data;
        if (this.moduleStagesList[0]['userRoles'] != null) {
          this.userRolesList = this.moduleStagesList[0]['userRoles'].split(",");
          if (this.userRolesList.length > 0 && this.userRolesList.length == 1) {
            this.isShowUserRoleSingle = true;
            this.selectedUserRoleValue = this.userRolesList[0];

          } else if (this.userRolesList.length > 1) {
            this.isShowUserRoleSingle = false;
            for (const element of this.userRolesList) {
              this.userRoleDropdown = this.userRoleDropdown.concat({
                valueExp: element,
                displayExp: element
              });
            }
          }
        }
        if (this.moduleStagesList[0]['noOfLevels']) {
          if (this.moduleStagesList[0]['noOfLevels'] == 1) {
            this.isShowLevelSingle = true;
            this.selectedLevelValue = 1;
          } else {
            let j = 1;
            while (j > this.moduleStagesList[0]['noOfLevels']) {
              this.levels.push(j);
              j++;
            }
            this.isShowLevelSingle = false;
            for (const element of this.levels) {
              this.levelDropdown = this.levelDropdown.concat({
                valueExp: element,
                displayExp: element
              });
            }
          }
        } else {
          this.levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
          this.isShowLevelSingle = false;
          for (const element of this.levels) {
            this.levelDropdown = this.levelDropdown.concat({
              valueExp: element,
              displayExp: element
            });
          }
        }

        if (user.userRole != null) {
          if (this.isShowUserRoleSingle) {
            this.getAllModuleStageUsersList(stage);
          } else {
            for (const element of this.userRoleDropdown) {
              if (element.valueExp == user.userRole) {
                this.selectedUserRole = [{
                  valueExp: element.valueExp,
                  displayExp: element.displayExp
                }]
                this.selectedUserRoleValue = user.userRole;
                this.getAllModuleStageUsersList(stage);
              }
            }
          }

        }
        if (user.userLevel != null) {
          for (const element of this.levelDropdown) {
            if (element.valueExp == user.userLevel) {
              this.selectedLevel = [{
                valueExp: element.valueExp,
                displayExp: element.displayExp
              }]
            }
          }
        }
      })

    this.stageUserData['module'] = stage['module'];
    this.stageUserData['refNo'] = stage['refNo'];
    this.stageUserData['refDetails'] = stage['refDetails'];
    this.stageUserData['stageName'] = stage['stageName'];
    this.stageUserData['version'] = stage['version'];
    this.stageUserData['slNo'] = user.taskStageUsersPk.slNo;
    this.selectedUserValue = user.taskStageUsersPk.userId;
    this.selectedLevelValue = user.userLevel;
    this.selectedUserRoleValue = user.userRole;
    this.operationFlag = "EDIT";
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.title = stage.stageName;
    this.qmsservice.isSwitchUSerPopupOpened = false;
    this.visibleAddOrEditStageUserPopup = this.dialog.open(this.addOrEditStageUserPopup, this.addOrEditStageUserPopupConfig);
  }

  deleteStageUserFunc(stage: any, user: any) {
    this.stageUserData = user;
    this.stageData = stage;
    this.stageUserData['deleteReason'] = "";
    this.stageUserData['module'] = stage['module'];
    this.stageUserData['refNo'] = stage['refNo'];
    this.stageUserData['refDetails'] = stage['refDetails'];
    this.stageUserData['stageName'] = stage['stageName'];
    this.stageUserData['version'] = stage['version'];
    this.stageUserData['slNo'] = user.taskStageUsersPk.slNo;
    this.stageUserData['userId'] = user.taskStageUsersPk.userId;
    this.title = "Delete " + stage.stageName;
    this.visibleDeleteStageUserPopup = this.dialog.open(this.deleteStageUserPopup, this.deleteStageUserPopupConfig);
  }

  cancelAddAndEditStageUserFunction() {
    this.visibleAddOrEditStageUserPopup.close();
  }

  cancelAddAndEditFunction() {
    this.visibleEditStagePopup.close();
  }

  selectedNoIfAny: any = [];
  noIfAnyDropdown: any = [];
  selectedNoIfAnyValue: any;

  selectedAnyOrAll: any = [];
  anyOrAllDropdown: any = [];
  selectedAnyOrAllValue: any;

  selectedUser: any = [];
  userDropdown: any = [];
  selectedUserValue: any;

  selectedLevel: any = [];
  levelDropdown: any = [];
  selectedLevelValue: any;

  selectedUserRole: any = [];
  userRoleDropdown: any = [];
  selectedUserRoleValue: any;


  onNoIfAnySelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedNoIfAnyValue = item.valueExp;
      }
    }
  }

  onNoIfAnyRemoved(item: any) {
    this.selectedNoIfAnyValue = "";
  }

  anyOrAllTxt: string;
  noIfAnyTxt: string;

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };


  onAnyOrAllSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedAnyOrAllValue = item.valueExp;
        if (this.selectedAnyOrAllValue == "ALL") {
          this.selectedNoIfAnyValue = "";
        }
      }
    }
  }

  onAnyOrAllRemoved(item: any) {
    this.selectedAnyOrAllValue = "";
  }

  onUserRoleSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedUserRoleValue = item.valueExp;
      this.userDropdown = [];
      this.selectedUser = [];
      if (this.stageUserData.taskStageUsersPk != undefined) {
        this.stageUserData.taskStageUsersPk.userId = null;
      }

      this.getAllModuleStageUsersList(this.stageData);
    }
  }

  labelName: any;

  selectedTabValue(event: any) {
    this.labelName = event.tab.textLabel;
  }

  onUserRoleRemoved(item: any) {
    this.selectedUserRoleValue = "";
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  addAndEditFunction(stage: any) {
    this.isProcessing = true;
    delete stage['updatedOn'];
    stage['noIfAny'] = this.selectedNoIfAnyValue;
    stage['anyOrAll'] = this.selectedAnyOrAllValue;
    this.appService.updateTaskStage(stage).subscribe({
      next: (data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
          this.visibleEditStagePopup.close();
          this.isProcessing = true;
          this.appService.getTaskStages(this.commonId, this.commonVersion)
            .subscribe((data: any) => {
              this.taskStagesList = data;
              for (const element of this.taskStagesList) {
                if (element.moduleStagesList.length > 0) {
                  if (element.moduleStagesList[0].overridable == "Y") {
                    element.isOverriden = true;
                  }
                }
                this.getUsersForStages(element);
              }
              this.isProcessing = false;
            })
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      }
    });
  }

  level: any;
  levelReqdMsg: any;
  level1: any;
  level1ReqdMsg: any;
  userRole: any;
  userRoleReqdMsg: any;
  user: any;
  userReqdMsg: any;
  user1: any;
  user1ReqdMsg: any;
  fieldValidation() {
    this.level = document.getElementById('level') as HTMLInputElement;
    this.levelReqdMsg = document.getElementById('level-required-msg') as HTMLInputElement;

    this.level1 = document.getElementById('level1') as HTMLInputElement;
    this.level1ReqdMsg = document.getElementById('level1-required-msg') as HTMLInputElement;

    this.userRole = document.getElementById('userRole') as HTMLInputElement;
    this.userRoleReqdMsg = document.getElementById('userRole-required-msg') as HTMLInputElement;

    this.user = document.getElementById('user') as HTMLInputElement;
    this.userReqdMsg = document.getElementById('user-required-msg') as HTMLInputElement;

    this.user1 = document.getElementById('user1') as HTMLInputElement;
    this.user1ReqdMsg = document.getElementById('user1-required-msg') as HTMLInputElement;

    if (this.stageData.stageName == "Signoff") {
      if (this.selectedLevelValue == "") {
        this.level1.style.border = '1px solid red';
        this.level1ReqdMsg.style.display = 'block';
      } else {
        this.level1.style.border = '';
        this.level1ReqdMsg.style.display = 'none';
      }
    } else if (this.selectedLevelValue == "") {
      this.level.style.border = '1px solid red';
      this.levelReqdMsg.style.display = 'block';
    } else {
      this.level.style.border = '1px solid black';
      this.levelReqdMsg.style.display = 'none';
    }

    if (this.selectedUserRoleValue == "") {
      this.userRole.style.border = '1px solid red';
      this.userRoleReqdMsg.style.display = 'block';
    } else {
      this.userRole.style.border = 'none';
      this.userRoleReqdMsg.style.display = 'none';
    }

    if (this.visibleAddButton) {
      if (this.selectedUser.length == 0) {
        this.user.style.border = '1px solid red';
        this.userReqdMsg.style.display = 'block';
      } else {
        this.user.style.border = 'none';
        this.userReqdMsg.style.display = 'none';
      }
    } else if (this.selectedUserValue == null) {
      this.user1.style.border = '1px solid red';
      this.user1ReqdMsg.style.display = 'block';
    } else {
      this.user1.style.border = 'none';
      this.user1ReqdMsg.style.display = 'none';
    }

  }

  IsApplicableRevApp: any = false;
  addAndEditStageUserFunction(stageUserData: any, from: any) {
    this.isProcessing = true;
    if (((this.selectedUser.length == 0 && this.visibleAddButton) || (this.selectedUserValue == "" && this.visibleEditButton) || this.selectedLevelValue == "" || this.selectedUserRoleValue == "")
      && from == "MAIN") {

      this.showSnackBar("Please fill in all mandatory fields", "E");
      this.isProcessing = false;
    } else if (this.IsApplicableRevApp) {
      for (const element of this.message.docsList) {
        if (element.documentId != null) {
          if (this.operationFlag == "ADD") {
            for (let i = 0; i < this.selectedUser.length; i++) {
              stageUserData['userId'] = this.selectedUser[i];
              stageUserData['userLevel'] = this.selectedLevelValue;
              stageUserData['userRole'] = this.selectedUserRoleValue;
              stageUserData['refNo'] = element.documentId;
              stageUserData['version'] = element.version;
              this.appService.addTaskStageUser(stageUserData).subscribe({
                next: (data: any) => {
                  this.isProcessing = false;
                  if (i === this.selectedUser.length - 1) {
                    if (data.resultType == "S") {
                      this.visibleAddOrEditStageUserPopup.close();
                      this.getUsersForStages(this.stageData);
                    } else {
                      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                        duration: 5000,
                        data: {
                          message: data.result,
                          type: data.resultType == 'S' ? 'Success' : 'Error',
                          buttonLabel: "Ok"
                        },
                        horizontalPosition: 'center',
                        verticalPosition: 'top',
                        panelClass: data.resultType == 'S' ? 'Success' : 'Error',
                      });
                      sb.onAction().subscribe(() => {
                        sb.dismiss();
                      });
                    }

                    this.isProcessing = false;
                  }
                }, error: (error) => {
                  this.displayMessage = error;
                  this.displaySuccessMessage = false;
                  this.displayErrorMessage = true;
                  this.isProcessing = false;
                  throw error;
                }
              });
            }
          } else {
            delete stageUserData['updatedOn'];
            delete stageUserData['requestedOn'];
            delete stageUserData['completedOn'];
            delete stageUserData['lastReminderSentOn'];
            stageUserData['userId'] = this.selectedUserValue;
            stageUserData['userLevel'] = this.selectedLevelValue;
            stageUserData['userRole'] = this.selectedUserRoleValue;
            stageUserData['refNo'] = element.documentId;
            stageUserData['version'] = element.version;
            this.appService.updateTaskStageUser(stageUserData).subscribe({
              next: (data: any) => {
                this.isProcessing = false;
                if (data.resultType == "S") {
                  if (this.visibleAddOrEditStageUserPopup == undefined) {
                    this.switchuserComponent.saveMethod();
                    this.switchuserComponent.cancelSwitchUserPopup();
                    this.switchuserComponent.closeConfirmationPopup();
                  } else {
                    this.visibleAddOrEditStageUserPopup.close();
                  }
                  this.getUsersForStages(this.stageData);
                } else {
                  let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                    duration: 5000,
                    data: {
                      message: data.result,
                      type: data.resultType == 'S' ? 'Success' : 'Error',
                      buttonLabel: "Ok"
                    },
                    horizontalPosition: 'center',
                    verticalPosition: 'top',
                    panelClass: data.resultType == 'S' ? 'Success' : 'Error',
                  });
                  sb.onAction().subscribe(() => {
                    sb.dismiss();
                  });
                }
                this.isProcessing = false;
              }, error: (error) => {
                this.displayMessage = error;
                this.displaySuccessMessage = false;
                this.displayErrorMessage = true;
                this.isProcessing = false;
                throw error;
              }
            });
          }
        }
      }
    } else if (this.operationFlag == "ADD") {
      for (let i = 0; i < this.selectedUser.length; i++) {
        stageUserData['userId'] = this.selectedUser[i];
        stageUserData['userLevel'] = this.selectedLevelValue;
        stageUserData['userRole'] = this.selectedUserRoleValue;
        this.appService.addTaskStageUser(stageUserData).subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (i === this.selectedUser.length - 1) {
              if (data.resultType == "S") {
                this.visibleAddOrEditStageUserPopup.close();
                this.getUsersForStages(this.stageData);
              }
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: data.result,
                  type: data.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: data.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
              this.isProcessing = false;
            }
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      }
    } else {
      delete stageUserData['updatedOn'];
      delete stageUserData['requestedOn'];
      delete stageUserData['completedOn'];
      delete stageUserData['lastReminderSentOn'];
      stageUserData['userId'] = this.selectedUserValue;
      stageUserData['userLevel'] = this.selectedLevelValue;
      stageUserData['userRole'] = this.selectedUserRoleValue;
      this.appService.updateTaskStageUser(stageUserData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            if (this.qmsservice.isSwitchUSerPopupOpened) {
              this.switchuserComponent.saveMethod();
              this.switchuserComponent.cancelSwitchUserPopup();
              this.switchuserComponent.closeConfirmationPopup();

            } else {
              this.visibleAddOrEditStageUserPopup.close();
            }
            this.getUsersForStages(this.stageData);
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }

  }

  deleteFunction() {
    this.isProcessing = true;
    if (this.stageUserData.deleteReason == "") {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      delete this.stageUserData['updatedOn'];
      delete this.stageUserData['requestedOn'];
      delete this.stageUserData['completedOn'];
      delete this.stageUserData['lastReminderSentOn'];

      this.appService.deleteTaskStageUser(this.stageUserData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleDeleteStageUserPopup.close();
            this.getUsersForStages(this.stageData);
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeleteStageUserPopup.close();
  }

  deleteReason: any;

  deleteReasonRequiredMsg: any;

  deleteValidation() {
    this.deleteReason = document.getElementById('deleteReason') as HTMLInputElement;

    this.deleteReasonRequiredMsg = document.getElementById('deleteReason-required-msg') as HTMLInputElement;

    if (this.stageUserData.deleteReason == "") {
      this.deleteReason.style.border = '1px solid red';
      this.deleteReasonRequiredMsg.style.display = 'block';
    } else {
      this.deleteReason.style.border = 'none';
      this.deleteReasonRequiredMsg.style.display = 'none';
    }
  }

  isStagesCollapsed = true;
  stageExpandCollapseFunc() {
    if (this.isStagesCollapsed) {
      this.isStagesCollapsed = false;
    } else {
      this.isStagesCollapsed = true;
    }
  }

  @ViewChild(DocumentViewerComponent) documentViewerComponent!: DocumentViewerComponent;
  docViewer!: DocViewerConfig;

  downloadDocuments(list: any) {
    this.isProcessing = true;
    try {
      const contentType = this.appService.getContentTypeByExtension(list.docExtn);
      const blob = this.appService.base64ToBlob(list.doc, contentType);

      const doc = {
        body: blob,
        contentType: contentType,
        extn: list.docExtn
      };

      this.docViewer = {
        blob,
        doc,
        docName: list.userRole + " " + 'Document',
        docExtension: list.docExtn
      };

      setTimeout(() => {
        this.documentViewerComponent?.openPopUp();
      }, 0);

    } catch (err) {
      console.error('Error while decoding or preparing document:', err);
      alert('Failed to load document.');
    } finally {
      this.isProcessing = false;
    }
  }

  //
  visibleEditCollaborativePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('editCollaborativePopup', { static: true }) editCollaborativePopup: TemplateRef<any>;
  editCollaborativePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  cancelAddAndEditCollaborativeFunction() {
    this.visibleEditCollaborativePopup.close();
  }
  editCollaborativeFunc(stage: any) {
    this.selectedNoIfAny = [];
    this.selectedNoIfAnyValue = "";
    this.selectedAnyOrAll = [];
    this.selectedAnyOrAllValue = "";
    this.stageData = stage;
    this.selectedNoIfAnyValue = stage.noIfAny;
    this.selectedAnyOrAllValue = stage.anyOrAll;
    if (stage.noIfAny) {
      for (const element of this.noIfAnyDropdown) {
        if (element.valueExp == stage.noIfAny) {
          this.selectedNoIfAny = element.valueExp;
        }
      }
    } else {
      this.selectedNoIfAny = '';
    }
    if (stage.anyOrAll) {
      for (const element of this.anyOrAllDropdown) {
        if (element.valueExp == stage.anyOrAll) {
          this.selectedAnyOrAll = element.valueExp;
        }
      }
    } else {
      this.selectedAnyOrAll = '';
    }
    this.visibleEditCollaborativePopup = this.dialog.open(this.editCollaborativePopup, this.editCollaborativePopupConfig);
  }

  addAndEditCollaborativeFunction(stage: any) {
    this.isProcessing = true;
    delete stage['updatedOn'];
    delete stage['requestedOn'];
    delete stage['completedOn'];
    delete stage['lastReminderSentOn'];
    stage['noIfAny'] = this.selectedNoIfAnyValue;
    stage['anyOrAll'] = this.selectedAnyOrAllValue;
    stage['userLevel'] = this.stageData.userLevel;
    stage['refNo'] = this.stageData.taskStageUsersPk.refNo;
    stage['module'] = this.stageData.module;
    stage['stageName'] = this.stageData.taskStageUsersPk.stageName;
    stage['version'] = this.stageData.taskStageUsersPk.version;

    this.appService.addTaskStageCollaborative(stage).subscribe({
      next: (data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
          this.visibleEditCollaborativePopup.close();
          this.isProcessing = true;
          this.appService.getTaskStages(this.commonId, this.commonVersion)
            .subscribe((data: any) => {
              this.taskStagesList = data;
              for (const element of this.taskStagesList) {
                if (element.moduleStagesList.length > 0) {
                  if (element.moduleStagesList[0].overridable == "Y") {
                    element.isOverriden = true;
                  }
                }
                this.getUsersForStages(element);
              }
              this.isProcessing = false;
            })
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {

          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      }
    });
  }

  @ViewChild(SwitchuserComponent) switchuserComponent!: SwitchuserComponent;
  openswitchuser(value: any, stage: any, user: any) {
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = "StageUsers";
    this.message.switchuserRole = value;
    this.stageData = stage;
    this.stageUserData = user;
    this.isProcessing = true;
    this.userDropdown = [];
    this.levelDropdown = [];
    this.userRoleDropdown = [];
    this.selectedLevel = [];
    this.selectedLevelValue = "";
    this.selectedUser = [];
    this.selectedUserValue = "";
    this.selectedUserRole = [];
    this.selectedUserRoleValue = "";

    this.appService.getModuleStages(stage['module'], stage['stageName'])
      .subscribe((data: any) => {
        this.isProcessing = false;
        this.moduleStagesList = data;
        if (this.moduleStagesList[0]['userRoles'] != null) {
          this.userRolesList = this.moduleStagesList[0]['userRoles'].split(",");
          if (this.userRolesList.length > 0 && this.userRolesList.length == 1) {
            this.isShowUserRoleSingle = true;
            this.selectedUserRoleValue = this.userRolesList[0];
          } else if (this.userRolesList.length > 1) {
            this.isShowUserRoleSingle = false;
            for (const element of this.userRolesList) {
              this.userRoleDropdown = this.userRoleDropdown.concat({
                valueExp: element,
                displayExp: element
              });
            }
          }
        }
        if (this.moduleStagesList[0]['noOfLevels']) {
          if (this.moduleStagesList[0]['noOfLevels'] == 1) {
            this.isShowLevelSingle = true;
            this.selectedLevelValue = 1;
          } else {
            let j = 1;
            while (j > this.moduleStagesList[0]['noOfLevels']) {
              this.levels.push(j);
              j++;
            }
            this.isShowLevelSingle = false;
            for (const element of this.levels) {
              this.levelDropdown = this.levelDropdown.concat({
                valueExp: element,
                displayExp: element
              });
            }
          }
        } else {
          this.levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
          this.isShowLevelSingle = false;
          for (const element of this.levels) {
            this.levelDropdown = this.levelDropdown.concat({
              valueExp: element,
              displayExp: element
            });
          }
        }

        if (user.userRole != null) {
          if (this.isShowUserRoleSingle) {
            this.getAllModuleStageUsersList(stage);
          } else {
            for (const element of this.userRoleDropdown) {
              if (element.valueExp == user.userRole) {
                this.selectedUserRole = [{
                  valueExp: element.valueExp,
                  displayExp: element.displayExp
                }]
                this.selectedUserRoleValue = user.userRole;
                this.getAllModuleStageUsersList(stage);
              }
            }
          }

        }
        if (user.userLevel != null) {
          for (const element of this.levelDropdown) {
            if (element.valueExp == user.userLevel) {
              this.selectedLevel = [{
                valueExp: element.valueExp,
                displayExp: element.displayExp
              }]
            }
          }
        }
      })



    this.stageUserData['module'] = stage['module'];
    this.stageUserData['refNo'] = stage['refNo'];
    this.stageUserData['refDetails'] = stage['refDetails'];
    this.stageUserData['stageName'] = stage['stageName'];
    this.stageUserData['version'] = stage['version'];
    this.stageUserData['slNo'] = user.taskStageUsersPk.slNo;
    this.selectedUserValue = user.taskStageUsersPk.userId;
    this.selectedLevelValue = user.userLevel;
    this.selectedUserRoleValue = user.userRole;
    this.operationFlag = "EDIT";
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.title = 'Switch ' + stage.stageName;
    this.qmsservice.moduleName = stage['module'];
    this.message.activityId = stage['refNo'];
    this.message.version = stage['version'];
    this.message.switchUserCurrentValue = user.taskStageUsersPk.userId;
    this.switchuserComponent.openswitchuser(user.userRole, 'SU');
  };
  onChildValueEmitted() {
    this.selectedUserValue = this.message.switchedUser ? this.message.switchedUser : null;
    this.addAndEditStageUserFunction(this.stageUserData, "SWITCH USER");
  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail(viewType: any, user: any) {

    let refNoMapping: Record<string, number> = {
      'TRN': this.data['trainingId'], 'DOCS': this.data['documentId'], 'DOCS_EXTENSION': this.data['extensionId'], 'DOCS_WITHDRAWAL': this.data['withdrawalId'], 'DOCS_DESTRUCTION': this.data['destructId'], 'FORMS': this.data['formId']
    }

    let moduleMapping: Record<string, string> = {
      'TRN': 'Training', 'DOCS': 'Documents', 'DOCS_EXTENSION': 'Documents Extension', 'DOCS_WITHDRAWAL': 'Documents Withdrawal', 'DOCS_DESTRUCTION': 'Documents Destruction', 'FORMS': 'Forms'
    }

    const $REJECT_REASON = this.data['module'] === 'FORMS' ? '' : 'REJECT_REASON,';

    let db = `CREATED_TS,END_TS,ACTION_FLAG,USER_FULLNAME,USER_LEVEL,USER_NAME,USER_ROLE,MODULE,STAGE_NAME,STAGE_SEQ,STATUS,REF_DETAILS,REQUESTED_ON,COMPLETED_ON,LAST_REMINDER_SENT_ON,${$REJECT_REASON}DOC,DOC_EXTN,COMMENTS,IS_ACTIVE,UPDATED_BY_USER,UPDATED_ON,DELETED_BY_USER,DELETED_REASON`;

    if (this.data['module'] === 'DOCS' || this.data['module'] === 'DOCS_EXTENSION' || this.data['module'] === 'DOCS_WITHDRAWAL' || this.data['module'] === 'DOCS_DESTRUCTION') {
      db += ",REASON_FOR_SIGNATURE";
    }

    if (this.data['module'] !== 'DOCS_WITHDRAWAL' && this.data['module'] !== 'DOCS_DESTRUCTION' && this.data['module'] !== 'DOCS_EXTENSION' && this.data['module'] !== 'FORMS') {
      db += ",VERSION";
    }

    const $Reject_Reason = this.data['module'] === 'FORMS' ? '' : 'Reject Reason,';

    let ui = `Created Timestamp,End Timestamp,Action,User Fullname,User Level,User Name,User Role,Module,Stage Name,Stage Seq,Status,Ref Details,Requested On,Completed On,Last Reminder Sent On,${$Reject_Reason}Document,Document Extension,Comments,Is Active,Updated By,Updated On,Deleted By,Deleted Reason`;

    if (this.data['module'] === 'DOCS' || this.data['module'] === 'DOCS_EXTENSION' || this.data['module'] === 'DOCS_WITHDRAWAL' || this.data['module'] === 'DOCS_DESTRUCTION') {
      ui += ",Reason For Signature";
    }

    if (this.data['module'] !== 'DOCS_WITHDRAWAL' && this.data['module'] !== 'DOCS_DESTRUCTION' && this.data['module'] !== 'DOCS_EXTENSION' && this.data['module'] !== 'FORMS') {
      ui += ",Version";
    }


    let report = `Created Timestamp,End Timestamp,Action,User Fullname,User Level,User Name,User Role,Module,Stage Name,Stage Seq,Status,Ref Details,Requested On,Completed On,Last Reminder Sent On,${$Reject_Reason}Document Extension,Comments,Is Active,Updated By,Updated On,Deleted By,Deleted Reason`;

    if (this.data['module'] === 'DOCS' || this.data['module'] === 'DOCS_EXTENSION' || this.data['module'] === 'DOCS_WITHDRAWAL' || this.data['module'] === 'DOCS_DESTRUCTION') {
      report += ",Reason For Signature";
    }

    if (this.data['module'] !== 'DOCS_WITHDRAWAL' && this.data['module'] !== 'DOCS_DESTRUCTION' && this.data['module'] !== 'DOCS_EXTENSION' && this.data['module'] !== 'FORMS') {
      report += ",Version";
    }


    if (viewType == 'overAll') {
      this.overAllTrail(db, ui, report, refNoMapping, moduleMapping, user);
    } else {
      this.individualTrail(db, ui, report, moduleMapping, user);
    }
  }

  overAllTrail(db: any, ui: any, report: any, refNoMapping: any, moduleMapping: any, user: any) {

    this.message.tableOrView_Name = "ONEQMS_TASK_STAGE_USERS_AU_VW";
    this.message.columnList_DB = db;
    this.message.columnList_UI = ui;

    this.message.whereClause_AU = " AND REF_NO = " + refNoMapping[this.data['module']] +
      " AND STAGE_NAME='" + this.labelName + "'" +
      " AND MODULE='" + this.data['module'] + "'";

    this.message.columnList_Report = report;
    this.message.whereClause_Report = " WHERE REF_NO = " + refNoMapping[this.data['module']] +
      " AND STAGE_NAME='" + this.labelName + "'" +
      " AND MODULE='" + this.data['module'] + "'";
    this.message.report_And_Popup_Name = moduleMapping[this.data['module']] + ' ' + this.labelName + ' Audit Trail';
    this.staticAuditTrailComponent.triggerTrail(user);
  }

  individualTrail(db: any, ui: any, report: any, moduleMapping: any, user: any) {

    this.message.tableOrView_Name = "ONEQMS_TASK_STAGE_USERS_AU_VW";
    this.message.columnList_DB = db;
    this.message.columnList_UI = ui;
    this.message.whereClause_AU = " AND REF_NO=" + user.taskStageUsersPk.refNo +
      " AND STAGE_NAME='" + user.taskStageUsersPk.stageName + "'" +
      " AND MODULE='" + user.module + "'" +
      " AND TASK_STAGE_USER_ID=" + user.taskStageUserId;

    this.message.columnList_Report = report;
    this.message.whereClause_Report = " WHERE REF_NO=" + user.taskStageUsersPk.refNo +
      " AND STAGE_NAME='" + user.taskStageUsersPk.stageName + "'" +
      " AND MODULE='" + user.module + "'" +
      " AND TASK_STAGE_USER_ID=" + user.taskStageUserId;
    this.message.report_And_Popup_Name = moduleMapping[this.data['module']] + ' ' + user.taskStageUsersPk.stageName + ' Audit Trail';
    this.staticAuditTrailComponent.triggerTrail(user);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    let refNoMapping: Record<string, number> = {
      'TRN': this.data['trainingId'], 'DOCS': this.data['documentId'], 'DOCS_EXTENSION': this.data['extensionId'], 'DOCS_WITHDRAWAL': this.data['withdrawalId'], 'DOCS_DESTRUCTION': this.data['destructId'], 'FORMS': this.data['formId']
    }

    let moduleMapping: Record<string, string> = {
      'TRN': 'Training', 'DOCS': 'Documents', 'DOCS_EXTENSION': 'Documents Extension', 'DOCS_WITHDRAWAL': 'Documents Withdrawal', 'DOCS_DESTRUCTION': 'Documents Destruction', 'FORMS': 'Forms'
    }

    const $REJECT_REASON = this.data['module'] === 'FORMS' ? '' : 'REJECT_REASON,';

    let db = `USER_FULLNAME,USER_LEVEL,USER_NAME,USER_ROLE,MODULE,STAGE_NAME,STAGE_SEQ,STATUS,REF_DETAILS,REQUESTED_ON,COMPLETED_ON,LAST_REMINDER_SENT_ON,${$REJECT_REASON}DOC_EXTN,COMMENTS,IS_ACTIVE,UPDATED_BY_USER,UPDATED_ON`;

    if (this.data['module'] === 'DOCS' || this.data['module'] === 'DOCS_EXTENSION' || this.data['module'] === 'DOCS_WITHDRAWAL' || this.data['module'] === 'DOCS_DESTRUCTION') {
      db += ",REASON_FOR_SIGNATURE";
    }

    if (this.data['module'] !== 'DOCS_WITHDRAWAL' && this.data['module'] !== 'DOCS_DESTRUCTION' && this.data['module'] !== 'DOCS_EXTENSION' && this.data['module'] !== 'FORMS') {
      db += ",VERSION";
    }

    const $Reject_Reason = this.data['module'] === 'FORMS' ? '' : 'Reject Reason,';

    let report = `User Fullname,User Level,User Name,User Role,Module,Stage Name,Stage Seq,Status,Ref Details,Requested On,Completed On,Last Reminder Sent On,${$Reject_Reason}Document Extension,Comments,Is Active,Updated By,Updated On`;

    if (this.data['module'] === 'DOCS' || this.data['module'] === 'DOCS_EXTENSION' || this.data['module'] === 'DOCS_WITHDRAWAL' || this.data['module'] === 'DOCS_DESTRUCTION') {
      report += ",Reason For Signature";
    }

    if (this.data['module'] !== 'DOCS_WITHDRAWAL' && this.data['module'] !== 'DOCS_DESTRUCTION' && this.data['module'] !== 'DOCS_EXTENSION' && this.data['module'] !== 'FORMS') {
      report += ",Version";
    }

    this.excelPdf.tableOrView_Name = "ONEQMS_TASK_STAGE_USERS_VW";
    this.excelPdf.columnList_DB = db;
    this.excelPdf.columnList_Report = report;
    this.excelPdf.whereClause_Report = " WHERE REF_NO = " + refNoMapping[this.data['module']] + " AND STAGE_NAME='" + this.labelName + "'" + " AND MODULE='" + this.data['module'] + "'";
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = moduleMapping[this.data['module']] + ' ' + this.labelName + ' Report';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }

  levelSearchText: string = '';
  userRoleSearchText: string = '';
  userSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  handleDropDownValidation(fieldId: string, selectedItems: [] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'execution-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    if (field) {
      field.style.color = shouldBeRed ? 'red' : '#005c8a';
    }

  }

  onUsersSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        setTimeout(() => { this.isAllUsersSelected = this.userDropdown.length == this.selectedUser.length; })
        this.handleDropDownValidation('execution-validation', this.selectedUser)
      });

  }

  @ViewChild('userFeild') userFeild: MatSelect;
  isAllUsersSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'userFeild') {
      if (this.isAllUsersSelected) this.userFeild.options.forEach((item: MatOption) => item.select());
      else {
        this.userFeild.options.forEach((item: MatOption) => item.deselect())
        this.selectedUser = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execution-validation', this.selectedUser)
      });
    }
  }

}

